export default "__VITE_ASSET__709283e6__"